import React, { useContext } from "react";
import InfoIconImage from "../../../../../images/info.svg";
import { ApplicationContext } from "../../../../../components/ApplicationProvider";
import {
    InfoIcon,
    PrivacyCard,
    PrivacyDescription,
    PrivacyLabel,
    PrivacySection,
    PrivacySubtitle,
    PrivacyTitle,
    Toggle,
    ToggleThumb,
} from "./GatewayPrivacySettings.styles";

type GatewayPrivacySettingsProps = {
    enabled: boolean;
    disabled?: boolean;
    onToggle: () => void;
};

const GatewayPrivacySettings: React.FC<GatewayPrivacySettingsProps> = ({
    enabled,
    disabled = false,
    onToggle,
}) => {
    const { t } = useContext(ApplicationContext);

    return (
        <PrivacySection>
            <PrivacyLabel>
                {t("devices.gateways.add_gateway_modal.data_privacy")}
                <InfoIcon src={InfoIconImage} alt="Info" />
            </PrivacyLabel>
            <PrivacyDescription>
                {t("devices.gateways.add_gateway_modal.description")}
            </PrivacyDescription>
            <PrivacyCard>
                <div>
                    <PrivacyTitle>{t("devices.gateways.add_gateway_modal.default")}</PrivacyTitle>
                    <PrivacySubtitle>
                        {t("devices.gateways.add_gateway_modal.essential_description")}
                    </PrivacySubtitle>
                </div>
                <Toggle
                    type="button"
                    enabled={enabled}
                    onClick={onToggle}
                    disabled={disabled}
                    aria-label="Toggle data privacy"
                    aria-pressed={enabled}
                >
                    <ToggleThumb enabled={enabled} />
                </Toggle>
            </PrivacyCard>
        </PrivacySection>
    );
};

export default GatewayPrivacySettings;
